import { SVGProps, useId } from 'react';

type HumanDrawnDashColor = 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'light' | 'dark' | 'highlight';

type HumanDrawnDashProps = Omit<SVGProps<SVGSVGElement>, 'color'> & {
  color?: HumanDrawnDashColor;
};

const DASH_PATH =
  'M4 7.2 C34 6.9 67 6.5 101 5.9 C134 5.3 166 4.8 196 4.4 C196.7 5.9 194.9 6.8 192.9 6.6 C162.7 7.1 132.1 7.6 99.7 8 C66.3 8.4 34.2 8.6 4.8 8.8 C3.6 8.7 3.2 7.9 4 7.2Z';

export function HumanDrawnDash({ color = 'primary', className, ...props }: HumanDrawnDashProps) {
  const gradientId = `human-drawn-dash-gradient-${useId().replace(/:/g, '')}`;
  const colorClass = color === 'highlight' ? '' : `text-${color}`;
  const mergedClassName = [colorClass, className].filter(Boolean).join(' ');

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="10" viewBox="0 0 200 10" fill="none" className={mergedClassName} {...props}>
      {color === 'highlight' ? (
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#009EE3" />
            <stop offset="34%" stopColor="#7491ED" />
            <stop offset="68%" stopColor="#D96ECC" />
            <stop offset="100%" stopColor="#FF5479" />
          </linearGradient>
        </defs>
      ) : null}
      <path d={DASH_PATH} fill={color === 'highlight' ? `url(#${gradientId})` : 'currentColor'} />
    </svg>
  );
}

export type { HumanDrawnDashColor, HumanDrawnDashProps };
